// Supabase client used by src/lib/storage.js for all reads/writes.
//
// To use this for real: create a Supabase project, run the migration in
// supabase/migrations/0001_app_storage.sql (SQL Editor tab), copy
// .env.example to .env, and fill in VITE_SUPABASE_URL /
// VITE_SUPABASE_ANON_KEY from the project's Settings > API page.
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Missing credentials shouldn't crash the app on load — just warn once, in
// dev, so it's obvious why every storage.js call is about to fail.
if ((!supabaseUrl || !supabaseAnonKey) && import.meta.env.DEV) {
  console.warn(
    "[supabaseClient] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set. " +
      "Copy .env.example to .env and fill in your Supabase project's values once one exists. " +
      "The app doesn't need this yet — it's still running on localStorage (see src/lib/storage.js)."
  );
}

export const supabase = createClient(supabaseUrl || "https://placeholder.supabase.co", supabaseAnonKey || "placeholder-anon-key");
